module.exports = __webpack_public_path__ + "img/7C.329b07cf.png";